module.exports = __webpack_public_path__ + "static/img/functionIcon2.1881e00.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/functionIcon2.png
// module id = uz8N
// module chunks = 1